import apiWrapper from "@apiWrapper";

export const shareLink = async (params: {
  email: string;
  first_name?: string;
  last_name?: string;
  url: string;
}) => apiWrapper("/shared_links", "POST", params);
